import axios from 'axios';
import LoginModel from '../components/login.model';
import { getUrl } from './service-utils';
import { SignupModel } from '../components/forms/signup-form';

export const API_URL = getUrl();

export const login = async (login: LoginModel) => {
  const { email, password } = login;
  return axios
    .post(API_URL + 'users/login', { email, password })
    .then((response) => {
      if (response.data.token) {
        localStorage.setItem('user', JSON.stringify(response.data));
      }

      return true;
    });
};

export const logout = async () => {
  localStorage.removeItem('user');
};

export const getCurrentUser = () => {
  const user = localStorage.getItem('user');
  if (!user) return null;

  const userData = JSON.parse(user);
  // Response shape: { status, token, data: { user: {...} } }
  return userData.data?.user ?? userData.data ?? null;
};

export const getAuthToken = (): string | null => {
  const user = localStorage.getItem('user');
  if (!user) return null;

  const userData = JSON.parse(user);
  return userData.token || null;
};

export const signUp = async (signup: SignupModel) => {
  return axios.post(API_URL + 'users/signup', signup).then((response) => {
    if (response.data.token) {
      localStorage.setItem('user', JSON.stringify(response.data));
    }

    return true;
  });
};

export const resetPassword = async (resetPassword: any) => {
  return axios
    .patch(API_URL + 'users/resetPassword', resetPassword)
    .then((response) => {
      if (response.data.status === 'success') {
        return true;
      }

      return false;
    });
};

export const sendForgotPasswordLink = async (email: string) => {
  const emailModel = { email: email };
  return axios
    .post(API_URL + 'users/forgotPassword', emailModel)
    .then((response) => {
      if (response.data.status !== 'success') {
        console.log(response.data.message);
      }

      return true;
    });
};
